import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import UserFilter from "../../../../app/core/components/UserFilter/UserFilter";
import { useGetCommercialistaQuery } from "../../../api/admin/gestisciCommercialistiApi";
import { TABLE_ROWS_NUMBER } from "../../../../utils/constants/tables";
import { useEditAdminPracticesMutation } from "../../../api/admin/gestisciPraticheApi";
import { toast } from "react-toastify";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import { useGetProfileCategoryQuery } from "../../../api/admin/gestioneNewsApi";
import Avatar from "@mui/material/Avatar";
import { formatItalianDate } from "../../../../utils/functions/date-utils";

const FormPratica = ({ practice, userData }) => {
  const [showAll, setShowAll] = useState(false);

  const DEFAULT_ADMIN_VALUE = {
    id: practice?.adminId,
    name: practice?.commDisplayName,
    surname: "",
  };
  const { t } = useTranslation();
  const [debouncedInputOperatorValue, setDebouncedInputOperatorValue] =
    useState("");
  const [selectedOperator, setSelectedOperator] = useState(DEFAULT_ADMIN_VALUE);

  const [page] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });

  const { data: dataListCategory } = useGetProfileCategoryQuery();
  const {
    data: operatorsData,
    isLoading: isOperatorLoading,
    isFetching: isOperatorFetching,
  } = useGetCommercialistaQuery({
    page,
    value: debouncedInputOperatorValue,
  });

  const [editAdmin] = useEditAdminPracticesMutation();

  const handleEditAdminPractices = () => {
    const bodyEditAdmin = {
      adminId: selectedOperator?.id,
      practiceId: practice?.id,
    };
    editAdmin(bodyEditAdmin)
      .then((res) => {
        if (res.data.Result !== 1) {
          toast.error(res.data.Exception || t("OperatorUpdated"));
          return;
        }
        toast.success(t("OperatorUpdated"));
      })
      .catch(() => {
        toast.error(t("OperatorUpdated"));
      });
  };

  const formData = {
    [t("Name")]: userData?.name,
    [t("Surname")]: userData?.surname,
    [t("CF")]: userData?.fiscalCode,
    Email: userData?.email,
    [t("Studio")]: userData?.studioName,
    [t("Company")]: userData?.userCompany?.name,
    [t("Role")]: dataListCategory?.Data?.find(
      (el) => el.id === userData?.employmentStatusId
    )?.name,
  };

  return (
    <Card className="p-5 rounded-xl">
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: "lightgray" }} aria-label="recipe">
            {userData?.name && userData?.surname
              ? (userData?.name[0] + userData?.surname[0]).toUpperCase()
              : ""}
          </Avatar>
        }
        title={userData?.name + " " + userData?.surname}
        subheader={`${t("PracticeOpening")}: ${formatItalianDate(
          practice?.createdAt
        )}`}
      />
      <Button
        className="w-full"
        variant="outlined"
        onClick={() => setShowAll(!showAll)}
      >
        {showAll ? "Nascondi" : "Mostra"}
      </Button>
      <CardContent className={showAll ? "flex flex-col gap-7" : "hidden"}>
        {Object.entries(formData).map(([key, value]) => (
          <>
            <div className="w-11/12 flex justify-between">
              <Typography>{key}</Typography>
              <Typography
                fontWeight={700}
                color={[t("Company"), t("Role")].includes(key) ? "green" : ""}
              >
                {value || "N/A"}
              </Typography>
            </div>
            <Divider />
          </>
        ))}
        <div className="flex space-x-4">
          <UserFilter
            selectedUser={selectedOperator}
            setSelectedUser={setSelectedOperator}
            usersList={operatorsData?.Data?.items || []}
            setDebouncedInputUserValue={setDebouncedInputOperatorValue}
            isUsersLoading={isOperatorLoading || isOperatorFetching}
            externalLabel={`${t("BriefSearchOperator")}`}
            externalPlaceholder={`${t("ExtSearchOperator")}`}
            externalNegativeLabel={t("NoOperatorFound")}
          />

          <Tooltip title={`${t("ChangeOperator")}`}>
            <CoreButton
              testo={t("Edit")}
              onClick={handleEditAdminPractices}
              className={"btn-round bg-green-500 disabled:bg-green-100"}
              variant="contained"
              disabled={selectedOperator?.id === DEFAULT_ADMIN_VALUE.id}
            />
          </Tooltip>
        </div>
      </CardContent>
    </Card>
  );
};

export default FormPratica;
